import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function isSaasSystemRole(role?: string): boolean {
  const normalized = String(role || '').toLowerCase();
  return normalized === 'super_admin'
    || normalized === 'super_admin_assistente'
    || normalized === 'saas_admin'
    || normalized === 'saas_admin_assistente';
}

export default function SaasPrivateRoute() {
  const { usuario, isAutenticado, isCarregando } = useAuth();

  if (isCarregando) {
    return (
      <div className="saas-loading-screen">
        <div className="saas-spinner-large"></div>
        <p>Verificando credenciais de segurança...</p>
      </div>
    );
  }

  // Se não estiver autenticado OU não tiver as roles de administrador do sistema, redireciona para o login do SaaS
  const roles = Array.isArray(usuario?.roles) ? usuario!.roles : [];
  const ehAdmin = roles.some((role) => isSaasSystemRole(role))
    || isSaasSystemRole(usuario?.tipo_usuario);

  if (!isAutenticado || !ehAdmin) {
    console.warn('Acesso negado ao portal SaaS. Redirecionando para login.');
    return <Navigate to="/saas/login" replace />;
  }

  return <Outlet />;
}
